<template>
  <section class="attr">
    <div class
         v-if="product">
      <Laptop :product="product"
              @setStep="setStep"
              @getAttr="getAttr"
              v-if="product.catId==19" />
      <Phone :product="product"
             @setStep="setStep"
             @getAttr="getAttr"
             v-else />
    </div>
    <button class="ahs-track-click"
            @click="onAssess"
            :class="step >= product.attrValue.length-1 ?'':'disabled'">免费询价</button>
  </section>
</template>
  
<script>
import Phone from "../../../components/PC/Product/Phone";
export default {
  data () {
    return {
      cats: [
        { id: 1, name: "手机" },
        { id: 2, name: "平板" },
        { id: 19, name: "笔记本" },
        { id: 22, name: "台式机" },
        { id: 9, name: "相机" },
        { id: 13, name: "数码" }
      ],
      active: 1,
      catId: 1,
      brandId: 1,
      keyword: "",
      size: 15,
      step: 0,
      line: 0,
      attrs: []
    };
  },
  components: {
    Phone
  },
  computed: {
    product () {
      return this.$store.state.oldproduct.product;
    }
  },
  inject: ["reload"],
  methods: {
    setStep (step) {
      this.step = step;
      let line = this.count;
      this.line = parseInt(line * this.step);
      console.log(step)
    },
    getAttr (data) {
      this.attrs = data;
    },
    onAssess () {
      let goodsId = this.product.product.goodsId;
      let params = {
        goodsId: goodsId,
        attrvalueId: this.attrs.join(",")
      };
      console.log(params);
      //   Indicator.open("估价中 ...");
      this.$store.dispatch("assess/fetchAssessData", { params }).then(() => {
        if (this.$store.state.assess.assess.assessAmount > 0) {
          this.$store.commit('user/setVisibleValue');
          window._hmt.push([
            "_trackEvent",
            "获取评估价格",
            "点击",
            this.$store.state.assess.assess.goodsName,
            this.$store.state.assess.assess.assessAmount
          ]);
          localStorage.assess = JSON.stringify(this.$store.state.assess.assess);
          this.reload();
          //   this.$router.push({ path: "/assess" });
        } else {
          this.$message({
            message: "估价失败,请稍后再试.",
            type: "warning"
          });
          //   Toast("估价失败,请稍后再试.");
        }
        // Indicator.close();
      });
    }
  },
  mounted () {
    // this.fetchProductData();
  }
};
</script>
  
<style scoped>
.ahs-track-click {
  width: 90%;
  display: block;
  margin: 0.05rem auto;
  background: #ff4747;
  color: #fff;
  font-size: 16px;
  line-height: 42px;
  text-align: center;
  cursor: pointer;
  border: 0;
}
.ahs-track-click:hover {
  color: #fff;
}
.ahs-track-click.disabled {
  background: #bababa !important;
  pointer-events: none;
  cursor: default;
}
</style>
  